export const armReactKeys = (arms)=>{
    const occurrencesByContent = new Map();
    return arms.map((arm)=>{
        var _occurrencesByContent_get;
        const content = JSON.stringify(arm);
        const occurrence = (_occurrencesByContent_get = occurrencesByContent.get(content)) !== null && _occurrencesByContent_get !== void 0 ? _occurrencesByContent_get : 0;
        occurrencesByContent.set(content, occurrence + 1);
        return "".concat(content, "#").concat(occurrence);
    });
};
const COLLAPSIBLE_STRING_FIELDS = {
    agreementName: true,
    clientName: true,
    contactName: true
};
const isCollapsibleStringField = (key)=>key in COLLAPSIBLE_STRING_FIELDS;
const soleFieldKey = (arm)=>{
    const keys = Object.entries(arm).filter((param)=>{
        let [, value] = param;
        return value != null;
    }).map((param)=>{
        let [key] = param;
        return key;
    });
    return keys.length === 1 ? keys[0] : null;
};
export const collapsibleStringGroup = (arms)=>{
    if (arms.length < 2) return null;
    const keys = arms.map(soleFieldKey);
    const field = keys[0];
    if (field == null || !isCollapsibleStringField(field)) return null;
    if (!keys.every((key)=>key === field)) return null;
    const predicates = arms.map((arm)=>arm[field]).filter((predicate)=>predicate != null);
    if (predicates.length !== arms.length) return null;
    return {
        field,
        predicates
    };
};
export const armChipTestIds = (armTestId)=>({
        AgreementName: "".concat(armTestId, "-agreement-name"),
        ClientName: "".concat(armTestId, "-client-name"),
        ClientPresence: "".concat(armTestId, "-client-presence"),
        ContactName: "".concat(armTestId, "-contact-name"),
        Status: "".concat(armTestId, "-status"),
        EffectiveDate: "".concat(armTestId, "-effective-date"),
        EffectiveDateMode: "".concat(armTestId, "-effective-date-mode"),
        LastUpdated: "".concat(armTestId, "-last-updated"),
        ModifiedBy: "".concat(armTestId, "-modified-by"),
        NetDays: "".concat(armTestId, "-net-days"),
        Settings: "".concat(armTestId, "-settings"),
        Services: "".concat(armTestId, "-services"),
        Packages: "".concat(armTestId, "-packages"),
        Bundles: "".concat(armTestId, "-bundles"),
        AndConnector: (index)=>"".concat(armTestId, "-and-connector-").concat(index)
    });
